/** @format */

import React, { useState } from "react";
import { Typography, Box, Card, Button, Skeleton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const DynamicContentRenderer = ({ content, disruptCareerLoading }) => {
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const parseContent = (text) => {
    return text.split("\n\n").map((section, index) => {
      const lines = section.split("\n").filter((line) => line.trim() !== "");
      const idx = lines[0].indexOf(":");
      const title = lines[0].substring(0, idx + 1).trim();
      const body = lines[0].substring(idx + 1).trim();
      const previewText = body.split(" ").slice(0, 30).join(" ") + "..."; // Show first 30 words
      const isExpandable = body.split(" ").length > 30;

      return (
        <Card
          key={index}
          sx={{
            marginBottom: 2,
            boxShadow: "none !important",
            background: "rgb(226 245 255)",
            padding: 2.5,
          }}
        >
          <Box display="flex" alignItems="flex-start" gap={1.5}>
            <Typography sx={{ fontSize: 15, fontWeight: 600 }}>{title}</Typography>
          </Box>
          <Typography sx={{ fontSize: 14, fontWeight: 400, marginTop: 1 }}>
            {expanded[index] ? body : previewText}
            {isExpandable && (
              <Button
                onClick={() => toggleExpand(index)}
                sx={{ fontSize: 13, p: 0, textTransform: "capitalize" }}
              >
                <ExpandMoreIcon
                  sx={{
                    transform: expanded[index] ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "0.3s",
                  }}
                />
                {expanded[index] ? "Read Less" : "Read More"}
              </Button>
            )}
          </Typography>
        </Card>
      );
    });
  };

  return (
    <Box sx={{ padding: 2, margin: "auto" }}>
      {disruptCareerLoading ? (
        // Show skeleton loaders when loading
        <>
          {[...Array(3)].map((_, i) => (
            <Card key={i} sx={{ marginBottom: 2, boxShadow: "0rem 0.25rem 0px #caedff", padding: 2.5 }}>
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="90%" height={15} />
              <Skeleton variant="text" width="80%" height={15} />
              <Skeleton variant="rectangular" width="100%" height={60} sx={{ marginTop: 1 }} />
            </Card>
          ))}
        </>
      ) : (
        parseContent(content)
      )}
    </Box>
  );
};

export default DynamicContentRenderer;
